"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledErrorWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledErrorWrapper", componentId: "sc-dc4z1h" }) `
  ${ui_1.backgroundGradient}
  padding: calc(${(props) => props.theme.spacers.base * 38}px) 0 calc(${(props) => props.theme.spacers.base * 51}px);

  ${(props) => (0, ui_1.mq)({
    paddingTop: [`calc(${props.theme.spacers.base * 19}px)`, `calc(${props.theme.spacers.base * 38}px)`],
    paddingBottom: [`calc(${props.theme.spacers.base * 25}px)`, `calc(${props.theme.spacers.base * 51}px)`],
})}
`;
